(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["furqx-underwear-size-guide-snippet"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-guide-modal')) {
    customElements.define('size-guide-modal', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.furqx-size-guide__trigger');
        this.closeButton = this.querySelector('.furqx-size-guide__close');
        if (!this.dialog || !this.trigger || !this.closeButton || this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.trigger.addEventListener('click', () => this.dialog.showModal());
        this.closeButton.addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          const box = this.dialog.getBoundingClientRect();
          const outside = event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
          if (outside) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.trigger.focus({ preventScroll: true }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
